export default "__VITE_ASSET__DmMdZ_nT__"